module.exports = __webpack_public_path__ + "static/img/frameless-sign-with-flush-mount-post.88c73d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/pedestals/frameless-sign-with-flush-mount-post.jpg
// module id = 713
// module chunks = 0